module.exports = __webpack_public_path__ + "static/title-00436efd3637ecdbf1f55aef0984b040.svg";